import { push } from "react-router-redux";
import api, { handleSubmissionError } from "APP_ROOT/api";
import _ from "lodash";
import { toastr } from "react-redux-toastr";
import { ID } from "APP_ROOT/constants";
import { refreshCarts } from "MODULES/session/actions";
import { SUCCESS } from "LIB/submission";
import { print as printAction, label } from "LIB/zebra/print";
import { partInventories } from "MODULES/parts/pagination";
import * as actionTypes from "./actionTypes";
import partInventoriesPagination from "./pagination";
import { INTERNAL_OUTRIGHT_SALES_ITEM_ID, INVENTORY } from "./constants";

export const { search, setFilter, pageActions } = partInventoriesPagination;
export const { pageActions: partInventoriesPageActions } = partInventories;

function refreshInventories(dispatch, inventoryID) {
  return api.inventories.show(inventoryID).then(resp => {
    dispatch({ type: actionTypes.SET, inventory: resp.data });
  });
}

export function assignExchange(data) {
  return (dispatch, getState) => {
    const inventoryID =
      data.id || getState().inventoryDetail.getIn([INVENTORY, ID]);

    return api.inventories.assignExchange(inventoryID, data).then(resp => {
      dispatch({
        type: actionTypes.SET,
        inventory: resp.data
      });
      dispatch(pageActions.expire());
      return SUCCESS;
    });
  };
}

export function updateSeller(id, data) {
  return dispatch =>
    api.inventories.update(id, data).then(resp => {
      dispatch({
        type: actionTypes.SET,
        inventory: resp.data
      });
      dispatch(pageActions.expire());
      return SUCCESS;
    });
}

export function update(data) {
  return (dispatch, getState) => {
    const inventoryID =
      data.id || getState().inventoryDetail.getIn([INVENTORY, ID]);

    return api.inventories.update(inventoryID, data).then(resp => {
      dispatch({
        type: actionTypes.SET,
        inventory: resp.data
      });
      dispatch(pageActions.expire());
      return SUCCESS;
    });
  };
}

export function bulkUpdate(data) {
  return (dispatch, getState) => {
    const inventoryID = getState().inventoryDetail.getIn([INVENTORY, ID]);
    return api.inventories.bulkUpdate(data).then(() => {
      dispatch(pageActions.expire());
      refreshInventories(dispatch, inventoryID);
      return SUCCESS;
    });
  };
}

export function reclaim() {
  return (dispatch, getState) => {
    const inventoryID = getState().inventoryDetail.getIn([INVENTORY, ID]);

    return api.inventories.reclaim(inventoryID).then(() => {
      dispatch(pageActions.expire());
      refreshInventories(dispatch, inventoryID);
      return SUCCESS;
    });
  };
}

export function reserveForRepair(id) {
  return (dispatch, getState) => {
    const inventoryID = id || getState().inventoryDetail.getIn([INVENTORY, ID]);

    return api.inventories
      .reserveForRepair(inventoryID)
      .then(() => {
        dispatch(pageActions.expire());
        dispatch(partInventoriesPageActions.expire());
        refreshInventories(dispatch, inventoryID);
        return SUCCESS;
      })
      .catch(error => {
        handleSubmissionError(error);
      });
  };
}

export function reserveForSale(data) {
  return (dispatch, getState) => {
    const inventoryID =
      data.id || getState().inventoryDetail.getIn(["inventory", "id"]);

    return api.inventories.reserveForSale(inventoryID, data).then(() => {
      dispatch(pageActions.expire());
      refreshInventories(dispatch, inventoryID);
      return SUCCESS;
    });
  };
}

export function updateWithId(id, data) {
  return dispatch =>
    api.inventories.update(id, data).then(() => {
      dispatch(pageActions.expire());
      return SUCCESS;
    });
}

export function transfer(
  id,
  transferToLocationId,
  outgoingAwbNumber,
  specialInstructions
) {
  return dispatch =>
    api.inventories.transfers
      .create(id, transferToLocationId, outgoingAwbNumber, specialInstructions)
      .then(() => {
        dispatch({ type: actionTypes.SET_MODAL, showModal: true });
        dispatch(pageActions.expire());
        refreshInventories(dispatch, id);
        return SUCCESS;
      });
}

export function cancelTransfer(id, transferId) {
  return dispatch =>
    api.inventories.transfers.delete(id, transferId).then(() => {
      dispatch(pageActions.expire());
      refreshInventories(dispatch, id);
      return SUCCESS;
    });
}

export function cancelModTo(id, data = {}) {
  return dispatch =>
    api.inventories.update(id, { mod_to_id: null, ...data }).then(() => {
      dispatch(pageActions.expire());
      refreshInventories(dispatch, id);
      return SUCCESS;
    });
}

export function unreserveForSale() {
  return (dispatch, getState) => {
    const inventoryID = getState().inventoryDetail.getIn(["inventory", "id"]);

    return api.inventories
      .unreserveForSale(inventoryID)
      .then(resp => {
        dispatch({ type: actionTypes.SET, inventory: resp.data });
        dispatch(refreshCarts());
        return SUCCESS;
      })
      .catch(err => {
        const srpErr =
          _.get(err, "errors.srp_condition") ||
          _.get(err, "errors.srp_condition");
        if (srpErr) {
          toastr.error(
            "Error",
            "SRP Details are required prior to returning to stock"
          );
        } else {
          throw err;
        }
      });
  };
}

export function applyLotCost(data) {
  return (dispatch, getState) => {
    const inventoryID = getState().inventoryDetail.getIn(["inventory", "id"]);

    return api.inventories.applyLotCost(inventoryID, data).then(resp => {
      dispatch({ type: actionTypes.SET, inventory: resp.data });
      return SUCCESS;
    });
  };
}

export function print(data, id) {
  return (dispatch, getState) => {
    const inventoryID = getState().inventoryDetail.getIn([INVENTORY, ID]) || id;
    return api.inventories.print(inventoryID, data).then(resp => {
      if (!data.include_company_name) {
        resp.data.company_name = null;
      }

      if (data.notes) {
        data.notes = resp.data.notes;
      } else {
        data.notes = null;
      }

      printAction(label({ ...resp.data, ...data }));
      return SUCCESS;
    });
  };
}

export function unreserveForRepair() {
  return (dispatch, getState) => {
    const inventoryID = getState().inventoryDetail.getIn(["inventory", "id"]);

    return api.inventories.unreserveForRepair(inventoryID).then(resp => {
      dispatch({ type: actionTypes.SET, inventory: resp.data });
      dispatch(refreshCarts());
      return SUCCESS;
    });
  };
}

export function deleteInventory(data) {
  return (dispatch, getState) => {
    const inventoryID =
      data.id || getState().inventoryDetail.getIn(["inventory", "id"]);

    return api.inventories.deleteInventory(inventoryID).then(resp => {
      dispatch({ type: actionTypes.SET, inventory: resp.data });
      return SUCCESS;
    });
  };
}

export function show(id) {
  return (dispatch, getState) => {
    const inventoryContext = getState().router.location.pathname.includes("all")
      ? "all"
      : "part";
    return api.inventories.show(id, inventoryContext).then(resp => {
      dispatch({
        type: actionTypes.SET,
        inventory: resp.data
      });

      return SUCCESS;
    });
  };
}

export function addCostAdjustment(data, props) {
  return (dispatch, getState) => {
    const inventoryID = getState().inventoryDetail.getIn([INVENTORY, "id"]);

    return api.inventories.costAdjustments
      .create(inventoryID, data)
      .then(resp => {
        if (resp.data.inventory_id === inventoryID) {
          refreshInventories(dispatch, inventoryID);
          props.setAskedInternalOutright(
            !getState().inventoryDetail.getIn([
              INVENTORY,
              INTERNAL_OUTRIGHT_SALES_ITEM_ID
            ])
          );
        } else {
          toastr.warning(
            "Warning",
            "Cost Adjustment will be added to repaired inventory related to shop assist."
          );
        }
        return SUCCESS;
      });
  };
}

export function cancelCostAdjustment(id) {
  return (dispatch, getState) => {
    const inventoryID = getState().inventoryDetail.getIn([INVENTORY, "id"]);
    return api.inventories.costAdjustments
      .cancel(id)
      .then(() => {
        refreshInventories(dispatch, inventoryID);
        return SUCCESS;
      })
      .catch(error => {
        toastr.error("Error", _.get(error, "errors.base[0]"));
      });
  };
}

export function upload(data) {
  const file = data.scrap_report;
  return (dispatch, getState) =>
    api.attachments.upload(file.name).then(resp => {
      const inventoryID = getState().inventoryDetail.getIn([INVENTORY, "id"]);
      const { key, url } = resp.data;
      const inventory = { scrap_report: key };

      return api.attachments.toS3(url, file).then(() =>
        api.inventories.update(inventoryID, inventory).then(createResp => {
          dispatch({
            type: actionTypes.SET,
            inventory: createResp.data
          });
          return SUCCESS;
        })
      );
    });
}

export function returnCoreToCustomer() {
  return (dispatch, getState) => {
    const salesOrderLineItemId = getState().inventoryDetail.getIn([
      "inventory",
      "most_recent_sales_order_line_item",
      "id"
    ]);

    const code = getState().inventoryDetail.getIn([
      "inventory",
      "most_recent_sales_order_line_item",
      "sales_order_code"
    ]);

    return api.salesOrders.lineItems
      .returnCoreToCustomer(salesOrderLineItemId)
      .then(resp => {
        dispatch({ type: actionTypes.SET, inventory: resp.data });
        toastr.success(
          "Success",
          `A Note has been created under Exchange ${code}, to indicate that the core has been rejected`
        );
      });
  };
}

export function returnConsignment(data) {
  return (dispatch, getState) => {
    const inventoryId = getState().inventoryDetail.getIn([INVENTORY, ID]);

    return api.inventories.cancelConsignment(inventoryId, data).then(resp => {
      refreshInventories(dispatch, resp.data.id);
      return SUCCESS;
    });
  };
}

export function createDummy(data) {
  return (dispatch, getState) => {
    const inventoryId = getState().inventoryDetail.getIn([INVENTORY, "id"]);

    return api.inventories.dummy.create(inventoryId, data).then(resp => {
      dispatch({ type: actionTypes.SET_DUMMY, dummy: resp.data });
      return SUCCESS;
    });
  };
}

export function updateDummy(data) {
  return (dispatch, getState) => {
    const inventoryId = getState().inventoryDetail.getIn([INVENTORY, "id"]);

    return api.inventories.dummy.update(inventoryId, data).then(resp => {
      dispatch({ type: actionTypes.SET_DUMMY, dummy: resp.data });
      return SUCCESS;
    });
  };
}

export function destroyDummy() {
  return (dispatch, getState) => {
    const inventoryId = getState().inventoryDetail.getIn([INVENTORY, "id"]);

    return api.inventories.dummy.destroy(inventoryId).then(() => {
      dispatch({ type: actionTypes.DESTROY_DUMMY });
      return SUCCESS;
    });
  };
}

export function splitInventory(data) {
  return (dispatch, getState) => {
    const inventoryId = getState().inventoryDetail.getIn([INVENTORY, "id"]);

    return api.inventories.split(inventoryId, data).then(() => {
      refreshInventories(dispatch, inventoryId);
      return SUCCESS;
    });
  };
}

export function createVendorRma(data) {
  return (dispatch, getState) => {
    const inventoryId = getState().inventoryDetail.getIn([INVENTORY, "id"]);
    api.inventories.vendorRmas.create(inventoryId, data).then(resp => {
      dispatch(push({ pathname: `/rmas/${resp.data.id}` }));
      return SUCCESS;
    });
  };
}

export function returnToCustomer(id, data) {
  return dispatch => {
    api.inventories.returnToCustomer(id, data).then(() => {
      refreshInventories(dispatch, id);
      return SUCCESS;
    });
  };
}

export function returnToCustomerV2(id, data) {
  return dispatch => {
    api.inventories.returnToCustomerRecords.create(id, data).then(() => {
      refreshInventories(dispatch, id);
      return SUCCESS;
    });
  };
}

export function undoScrap(id) {
  return dispatch =>
    api.inventories
      .undoScrap(id)
      .then(() => {
        refreshInventories(dispatch, id);
        return SUCCESS;
      })
      .catch(error => {
        toastr.error("Error", _.get(error, "errors.base[0]"));
      });
}



// WEBPACK FOOTER //
// ./app/modules/inventories/actions.js